var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 0.166638C10.9616 0.166638 8.48046 0.919299 6.37002 2.32944C4.25959 3.73959 2.61471 5.74388 1.64339 8.08887C0.672064 10.4339 0.417922 13.0142 0.913099 15.5036C1.40828 17.9931 2.63053 20.2797 4.42531 22.0745C6.22008 23.8693 8.50676 25.0915 10.9962 25.5867C13.4856 26.0819 16.066 25.8277 18.4109 24.8564C20.7559 23.8851 22.7602 22.2402 24.1704 20.1298C25.5805 18.0194 26.3332 15.5382 26.3332 13C26.3409 11.3125 26.0142 9.64024 25.372 8.07975C24.7298 6.51925 23.7848 5.10144 22.5916 3.90822C21.3984 2.71499 19.9806 1.76999 18.4201 1.12779C16.8596 0.485587 15.1873 0.158915 13.4998 0.166638ZM20.3248 17.0833C20.2199 17.2543 20.0747 17.3969 19.9018 17.4986C19.7288 17.6003 19.5336 17.658 19.3332 17.6666C19.1262 17.6639 18.9241 17.6033 18.7498 17.4916L12.3332 13.6416V7.16664C12.3332 6.85722 12.4561 6.56047 12.6749 6.34168C12.8937 6.12289 13.1904 5.99997 13.4998 5.99997C13.8093 5.99997 14.106 6.12289 14.3248 6.34168C14.5436 6.56047 14.6665 6.85722 14.6665 7.16664V12.3583L19.9165 15.5083C20.0511 15.5806 20.1693 15.68 20.2637 15.8001C20.3581 15.9203 20.4266 16.0587 20.4649 16.2066C20.5033 16.3545 20.5106 16.5087 20.4865 16.6596C20.4624 16.8104 20.4074 16.9547 20.3248 17.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e678cdf2622b25c99ebefbc8ec395a4a.svg";
export { ForwardRef as ReactComponent };